import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'

import { submitEULAError, submitEULASuccess } from './actions'
import { SUBMIT_EULA_ASYNC } from './constants'

const submitEULAEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(SUBMIT_EULA_ASYNC.INITIATE).mergeMap((action) =>
    api.login
      .submitEULA({
        eula_type: action.payload.type,
        eulaVersion: action.payload.eulaVersion,
      })
      .map(({ response }) => submitEULASuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(submitEULAError, error)))
  )

export default combineEpics(submitEULAEpic)
